import { STEP_SERVICE_BREAKDOWN, STEP_SERVICE_DETAILS, STEP_SERVICE_PACKAGES, STEP_SIGN_IN } from "pages/CustomerBookingCreate/constants"

const getStepAndServiceFromServiceCard = (categoryService) => {
  // const mappedservice = services?.services?.find(s => s?.type?.id === categoryService?.featured_service?.type_id)

  // const mappedExtendedPackages = mappedservice?.extended_packages?.filter(p => categoryService?.featured_service?.extended_package_ids?.includes(p?.id))
  // const mappedExtendedPackageItems = mappedservice?.extended_package_items?.filter(p => categoryService?.featured_service?.extended_package_item_ids?.includes(p?.id))
  const mappedExtendedPackages = categoryService?.featured_service?.extended_package_ids?.map(t=>({id:t}))
  const mappedExtendedPackageItems = categoryService?.featured_service?.extended_package_item_ids?.map(t=>({id:t}))
  switch (categoryService?.action_type) {
    case 'BOOK_SELECT_TESTS':
      return {
        destinationStep: STEP_SERVICE_PACKAGES,
        canAddToCart: true,
        prefill: {
          redirectStep: STEP_SERVICE_DETAILS,
          serviceCategory: categoryService,
          services: mappedExtendedPackageItems,
          packages: mappedExtendedPackages,
          rawService: categoryService
        }
      }
    case 'BOOK_PRE_SELECTED':
      return {
        destinationStep: STEP_SERVICE_PACKAGES,
        canAddToCart: true,
        prefill: {
          redirectStep: STEP_SERVICE_PACKAGES,
          serviceCategory: categoryService,
          services: mappedExtendedPackageItems,
          packages: mappedExtendedPackages,
          rawService: categoryService
        }
      }
    case 'BOOK_CONSULTATION_COVID':
      return {
        disabled: true
      }
    case 'BOOK_TELEMEDICINE':
      return {
        disabled: true,
      }
    case 'BOOK_PRE_SELECTED_EXTENDED':
      const isEmptyServiceAndPackage = mappedExtendedPackageItems.length === 0 && mappedExtendedPackages.length === 0
      return {
        destinationStep: STEP_SERVICE_PACKAGES,
        canAddToCart: !isEmptyServiceAndPackage,
        prefill: {
          redirectStep: STEP_SERVICE_PACKAGES,
          serviceCategory: categoryService,
          services: mappedExtendedPackageItems,
          packages: mappedExtendedPackages,
          rawService: categoryService
        }
      }
    default:
      return {
        disabled: true
      }
  }
}

export const mapActionTypeToStep = (actionType) => {
  switch (actionType) {
    case 'BOOK_SELECT_TESTS':
      return {
        destinationStep: STEP_SERVICE_DETAILS,
        canAddToCart: true
      }
    case 'BOOK_PRE_SELECTED':
      return {
        destinationStep: STEP_SIGN_IN,
        canAddToCart: false
      }
    case 'BOOK_CONSULTATION_COVID':
      return {
        disabled: true
      }
    case 'BOOK_TELEMEDICINE':
      return {
        disabled: true,
      }
    case 'BOOK_PRE_SELECTED_EXTENDED':
      return {
        destinationStep: STEP_SERVICE_DETAILS,
        canAddToCart: true
      }
    default:
      return {
        disabled: true
      }
  }
}

const mapCategoriesToServices = async (categories) => {
  const mapped = categories?.map(category => {
    return {
      ...category,
      bookings: category?.bookings?.map(categoryService => {
        return {
          ...categoryService,
          fillOptions: getStepAndServiceFromServiceCard(categoryService)
        }
      })
      // .filter(service => service.fillOptions?.prefill?.packages?.length > 0 || service.fillOptions?.prefill?.services?.length > 0)
    }
  })
  return mapped
}

export {
  getStepAndServiceFromServiceCard,
  mapCategoriesToServices
}
